import Layout from '@/layout'

const cashierRouter = {
  path: '/cashier',
  component: Layout,
  redirect: '/cashier/post_transaction',
  name: 'Nested',
  meta: {
    title: 'Thu ngân'
    // icon: 'list'
  },
  children: [
    {
      path: 'post_transaction',
      name: 'Giao dịch',
      // component: () => import('@/views/mci/cashier/postTransaction'),
      component: () =>
        import('@/views/mci/cashier/postTransactionSplited/index'),
      meta: {
        title: 'Giao dịch'
      }
    },
    {
      path: 'group_check_out',
      name: 'Trả phòng đoàn',
      component: () => import('@/views/mci/cashier/groupCheckout'),
      meta: {
        title: 'Trả phòng đoàn'
      }
    },
    {
      path: 'cancel_noshow_charge',
      name: 'Phí hủy không đến',
      component: () => import('@/views/mci/cashier/cancelNoshowCharge'),
      meta: {
        title: 'Phí hủy không đến'
      }
    }
  ]
}

export default cashierRouter
